import React from "react";

import DumbbellAlignment, { DumbbellAlignmentValues } from "components/visuals/DumbellAlignment";

import { selectRetailZoneCharacteristics } from "modules/customer/tools/location/retailers/retailersSlice";
import { useAppSelector } from "store";
import { selectTarget } from "modules/customer/tools/location/locationSlice";

const RetailZoneCharacteristics: React.FC = () => {
    const catchmentAreaDemographic = useAppSelector(selectRetailZoneCharacteristics);
    const targetIsSet = Boolean(useAppSelector(selectTarget)?.useRetailers);

    const chartValues: DumbbellAlignmentValues[] = [{
        lowCategory: "No stores",
        highCategory: "Many stores",
        label: "Number of stores",
        selectedValue: catchmentAreaDemographic.retailCentre.numberOfStores,
        targetValue: catchmentAreaDemographic.target.numberOfStores
    }, {
        lowCategory: "Low-end brands",
        highCategory: "High-end brands",
        label: "Brand positioning",
        selectedValue: catchmentAreaDemographic.retailCentre.brandPositioning,
        targetValue: catchmentAreaDemographic.target.brandPositioning,
        nullValueMessage: "Insufficient branded stores"
    }];

    return (
        <DumbbellAlignment chartValues={chartValues} targetIsSet={targetIsSet} dataCy="demographics-alignment" />
    );
};

export default RetailZoneCharacteristics;
